/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Form_Mapy_Panorama_UrlInputs */

const cs_form_mapy_panorama_url = /** @type {(inputs: Form_Mapy_Panorama_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`URL panoramatu Mapy.cz`)
};

const en_form_mapy_panorama_url = /** @type {(inputs: Form_Mapy_Panorama_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapy.cz panorama URL`)
};

/**
* | output |
* | --- |
* | "Mapy.cz panorama URL" |
*
* @param {Form_Mapy_Panorama_UrlInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const form_mapy_panorama_url = /** @type {((inputs?: Form_Mapy_Panorama_UrlInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Form_Mapy_Panorama_UrlInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_form_mapy_panorama_url(inputs)
	return cs_form_mapy_panorama_url(inputs)
});